import ProductListCard from './ProductListCard';

export default function ProductGrid({ products }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
            {products.map((product) => (
                <ProductListCard key={product._id || product.id} product={product} />
            ))}
        </div>
    );
}
